(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "lodash/isFunction", "./constants", "./update"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("lodash/isFunction"), require("./constants"), require("./update"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.isFunction, global.constants, global.update);
    global.mixin = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _isFunction, _constants, _update) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  _exports.__esModule = true;
  _exports["default"] = createMixin;
  _isFunction = _interopRequireDefault(_isFunction);
  var EVENT_SHOW = "vuewx:show";
  /**
   * watch the vuewx options and execute the directives when change happens.
   * this options is plugin options.
   *
   * In the entire application lifecycle, there should be only one vuewx update
   * exists.
   */

  function createMixin(Vue, options) {
    var mixin = {
      beforeCreate: function beforeCreate() {
        var _this = this;

        // vue components options.
        var $options = this.$options;
        var root = this[_constants.rootKey];

        if (!root[_constants.rootConfigKey]) {
          root[_constants.rootConfigKey] = {
            pausing: false,
            pending: null,
            beforeRouterLeave: null
          };
        }

        if (!(0, _isFunction["default"])($options[_constants.keyName]) || !$options[_constants.keyName]) {
          return;
        }

        if (this.$isServer) {
          return;
        }

        $options.computed = $options.computed || {};
        $options.computed.$wxInfo = $options[_constants.keyName];
        ["hook:activated", "hook:mounted"].forEach(function (lifecyle) {
          _this.$on(lifecyle, function () {
            if (_this[_constants.rootConfigKey]) {
              return;
            }

            _this[_constants.rootConfigKey] = true;

            if (root[_constants.rootConfigKey][_constants.pausing]) {
              root[_constants.rootConfigKey].pending = function () {
                (0, _update.batchUpdate)(function () {
                  return void (0, _update.update)(_this);
                });
              };

              return;
            }

            (0, _update.batchUpdate)(function () {
              return void (0, _update.update)(_this);
            });
          });
        });
        ["hook:deactivated", "hook:beforeDestroy"].forEach(function (lifecycle) {
          _this.$on(lifecycle, function () {
            if (!_this[_constants.rootConfigKey]) {
              return;
            }

            _this[_constants.rootConfigKey] = false;
            (0, _update.batchUpdate)(function () {
              return void (0, _update.update)(_this, true);
            }, 0);
          });
        });
        this.$on("hook:created", function () {
          _this.$watch("$wxInfo", function () {
            var _this2 = this;

            if (!this[_constants.rootConfigKey]) {
              return;
            }

            if (root[_constants.rootConfigKey][_constants.pausing]) {
              root[_constants.rootConfigKey].pending = function () {
                (0, _update.batchUpdate)(function () {
                  return void (0, _update.update)(_this2);
                });
              };

              return;
            }

            (0, _update.batchUpdate)(function () {
              return void (0, _update.update)(_this2);
            }); // 因为这个 beforeRouterLeave 被hooks使用后被重置为 null了。
            // 但是因为vue组件复用的问题，我没需要在每次变化的时候，重新设置一下此值。

            root[_constants.rootConfigKey].beforeRouterLeave = function () {
              console.log("I am being called.1");
              (0, _update.batchUpdate)(function () {
                return void (0, _update.update)(_this2, true);
              }, 0);
            };
          });

          root[_constants.rootConfigKey].beforeRouterLeave = function () {
            console.log("I am being called.2");
            (0, _update.batchUpdate)(function () {
              return void (0, _update.update)(_this, true);
            }, 0);
          };
        });

        if (root[_constants.rootConfigKey].navGuards || !root.$router) {
          return;
        }

        root[_constants.rootConfigKey].navGuards = true;
        root.$router.beforeEach(function (to, from, next) {
          root[_constants.rootConfigKey].pausing = true;
          root[_constants.rootConfigKey].pending = null;

          if (typeof root[_constants.rootConfigKey].beforeRouterLeave === "function") {
            root[_constants.rootConfigKey].beforeRouterLeave();

            root[_constants.rootConfigKey].beforeRouterLeave = null;
          }

          next();
        });
        root.$router.afterEach(function () {
          root.$nextTick(function () {
            root[_constants.rootConfigKey].pausing = false;

            if (typeof root[_constants.rootConfigKey].pending === "function") {
              root[_constants.rootConfigKey].pending();

              root[_constants.rootConfigKey].pending = null;
            } // refresh.

          });
        });
      }
    };
    return mixin;
  }
});
//# sourceMappingURL=mixin.js.map